import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const list = css`
  margin: 0;
  padding: 0;
  list-style: none;
  grid-column: span 12;
  display: flex;
  flex-wrap: wrap;
  column-gap: var(${themeVariables.spacing.xs});
  row-gap: var(${themeVariables.spacing.xs});

  ${mediaQuery(
    { max: 1023 },
    css`
      padding-left: var(${themeVariables.spacing.md});
      padding-right: var(${themeVariables.spacing.md});
    `,
  )}

  button {
    font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
    line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
    cursor: pointer;
    text-decoration: none;
  }
`;

const resetButtonBase = css`
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
`;

export const resetFacetButton = css`
  ${resetButtonBase};
  border: 1px solid color-mix(in srgb, var(${themeVariables.colors.stroke.selected}) 70%, white);
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: var(${themeVariables.spacing.xxs});
  padding: var(${themeVariables.spacing.xs});
  background-color: color-mix(
    in srgb,
    var(${themeVariables.colors.surface.interactive}) 10%,
    white
  );
  color: var(${themeVariables.colors.content.interactive});
  font-weight: var(${themeVariables.typography.body.fontWeight});
  font-family: var(${themeVariables.typography.body.fontFamily});
`;

export const resetAllButton = css`
  ${resetButtonBase};
  border: 0;
  padding: var(${themeVariables.spacing.xs}) 0;
  display: inline-flex;
  background-color: transparent;
  color: var(${themeVariables.colors.content.interactive});
  font-weight: 600;
  font-family: var(${themeVariables.typography.body.fontFamily});
`;
